import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import Profile from "../types/Profile";
import useDataSave, {DataSaveType} from "../../core/services/query/hooks/useDataSave";
import {ME_BASE_URL} from "../../../config/config";
import {useOidcClientContext} from "../../ui/context/OidcClientContext";
import useCustomerContext from "../../customers/hooks/useCustomerContext";

export default function useProfileSave(): DataSaveType<Profile> {
    const {client: oidcClient} = useOidcClientContext();
    const {languageCode} = useCustomerContext();
    const client = useAPIClient(ME_BASE_URL);

    client.onError(error => {
        if (error.statusCode === 401) {
            oidcClient.login({
                locale: languageCode,
            }).then();
        } else {
            throw error;
        }
    });

    return useDataSave<Profile>(
        ({id, ...rest}: Profile) => client.put(`profile`, rest),
    );
}
